import { useEffect, useState, useRef, useCallback } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import moment from "moment";
import Popup from "../../User/popup";
import { DropDownInput } from "../../components/_input/_dropdown";
import { TextArea } from "../../components/_input/_textArea";
import { DateInput3 } from "../../components/_input/_dateInput_3";
import { InputField } from "../../components/_input/_input";
import MaintenanceCalendarDialog from "../../components/MaintenanceCalendarDialog";
import { Route, Switch, useRouteMatch } from "react-router";
import PhoneDropDown from "../../components/_input/_phoneDropDown";
import config from '../../configuration/config';
import DatePicker from 'react-datepicker';
import { useHistory, useLocation } from "react-router";
import { GetMessages, formValidate } from '../../utils/validation';
import Joi from "joi";
import { useUserCart } from '../../User/hooks/useUserCart';
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import { toast } from "react-toastify";
import { UploadControl } from "../../components/_input/_uploadControl";
import * as journifyTrackingCarEvents from "../../services/trackingCarEvents";
import { Swiper, SwiperSlide } from "swiper/react";
function ServiceOrderPopup({

    maintenanceObjData

}) {
    const { t: trans, i18n } = useTranslation(["info", "eparts", "user"]);
    const { path } = useRouteMatch();
    const MechanicalGUID = "0a5e145a-bf3f-4a8e-aa7b-d8f0a1e0d9b0";
    const Body_PaintingGUID = "9ceb8b65-14a4-4a61-9223-a06ae0db53cf"
    const PaintingGUID = "22d24d95-04cd-4c88-88ec-317d940231e0";
    const BodyGUID = "5d22681e-6233-459c-92c0-d576141a7237";
    const OnlinepaintingGUID = "bb3a0cda-5601-430b-9bf8-7e523e5eb7a5";//دنتة اونلاين
    const OnlineDentingGUID = "fcaa28c6-de81-47a6-83a9-204d5b26a5ad";//دنتة اونلاين
    const CheckingGUID = "a4df3008-2236-4455-854b-da6ddd592364";//فحص
    const OnlineCheckingGUID = "8fedd3fb-03cf-4919-9b7e-492f16d913b9";//فحص اونلاين
    const GeneralRepairGUID = "619b5424-1a20-4e01-950a-a8d87f9f1c7e";//تصليح عام
    const OnlineGeneralRepairGUID = "d9af24f0-9932-4481-8136-403471ed6b84";//تصليح عام اونلاين
    const PERIODIC_MAINTENANCE_ID = 'EB199B7E-55BE-4AC8-B465-9A110B415CA8';

    const DynamicOptions = {
        [CheckingGUID]: OnlineCheckingGUID,
        [PaintingGUID]: OnlinepaintingGUID,
        [BodyGUID]: OnlineDentingGUID,
        [GeneralRepairGUID]: OnlineGeneralRepairGUID
    };

    let lang = (i18n.language || 'ar');
    const [showFinalPopup, setShowFinalPopup] = useState(false);
    const [showCalendar, setShowCalendar] = useState(false);
    const popRef = useRef(null);
    const [resOrderID, setResOrderID] = useState(null);
    const history = useHistory();
    const { changecartItem } = useUserCart();
    const [stepNum, setStepNum] = useState(1);
    const [activeVehicleTab, setActiveVehicleTab] = useState('myCars');
    const [dataFullNum, setDataFullNum] = useState(0);
    const [ServicesDataJson, setServiceDataJson] = useState({});
    const location = useLocation();
    const [maintenanceObj, setMaintenanceObj] = useState({ maintenanceObjData });

    const [warningPopup, setWarningPopup] = useState({ show: false, message: '' });
    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    useEffect(() => {
        setMaintenanceObj(maintenanceObjData);
        if (maintenanceObjData.showPopup == true)
            handleServiceOrder(maintenanceObjData);
    }, [maintenanceObjData]);

    useEffect(() => {

        function handleClickOutside(event) {
            if (popRef.current && !popRef.current.contains(event.target) && showFinalPopup === true) {
                setShowFinalPopup(false);
                setResOrderID(null);
                if (location.pathname)
                    history.push(location.pathname);

            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showFinalPopup]);


    //--------------------------------------------------

    const [Defult, setDefult] = useState({
        showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
    });

    const [infoPrice, setinfoPrice] = useState([{ Price: 0 }]);
    const [isLogin, setLogin] = useState(false);
    const [isSendeng, setIsSendeng] = useState(false);
    const [requestForm, setRequestForm] = useState({
        lastName: '',
        firstName: '',
        phone: '',
        email: '',
        subject: '',
        date: '',
        time: '',
        messageContent: '',
        myCarID: '',
        SiteID: null,
    });
    const LoginSchema = Joi.object({
        date: Joi.date().required().messages(GetMessages()),
        time: Joi.date().required().messages(GetMessages()),
        SerciveID: Joi.string().required().messages(GetMessages()),
        SiteID: Joi.string().required().messages(GetMessages()),
    });
    const notLoginSchema = Joi.object({
        date: Joi.date().required().messages(GetMessages()),
        time: Joi.date().required().messages(GetMessages()),
        SiteID: Joi.string().required().messages(GetMessages()),
        SerciveID: Joi.string().required().messages(GetMessages()),
        firstName: Joi.string().required().messages(GetMessages()),
        lastName: Joi.string().required().messages(GetMessages()),
        phone: Joi.string().required().messages(GetMessages()),
        year: Joi.string().required().messages(GetMessages())
    });


    const [filteredSettings, setFilteredSettings] = useState({
        brands: [],
        groups: [],
        models: [],
        productModels: []
    });


    const [settings, setSettings] = useState({
        brands: [],
        groups: [],
        models: [],
        productModels: []
    });
    const [brand, setBrand] = useState(null);
    const [type, setType] = useState(null);
    const [groupData, setGroupData] = useState([]);
    const [group, setGroup] = useState(null);
    const [vModelCode, setVModelCode] = useState([]);
    const [year, setYear] = useState(null);
    const handleFilteredModels = (option, vYear = year) => {

        setGroup(null);
        setType(null);
        setFilteredSettings({ ...filteredSettings, models: [], productModels: [] });
        setGroup(option);
        var fModels = [];
        try {

            const currentgroupData = settings?.groups?.filter(a => a.brandID == brand && a.productGroupID == option && a.Year == vYear);
            const ListTreeGroups = (currentgroupData && currentgroupData?.length > 0) ? currentgroupData[0].ListTreeGroups : option;

            // Split the comma-separated string into an array
            const listVArray = ListTreeGroups.split(',');

            // Assuming settings.productModels is an array of objects with properties productGroupID and Model
            fModels = settings?.productModels?.filter(a =>
                listVArray.includes(a.productGroupID) && a.Model == vYear
            );
        } catch {

            fModels = settings?.productModels?.filter(a => a.productGroupID == option && a.Model == vYear);
        }





        setFilteredSettings({ ...filteredSettings, productModels: fModels });

    };

    const handelSelectBrand = (option, vYear = year) => {
        setBrand(null);
        setType(null);
        setGroup(null);

        setFilteredSettings({ ...settings, groups: [], models: [], productModels: [] });
        setGroupData([]);
        setBrand(option);


        const fGroups = settings?.groups?.filter(a => a.brandID == option && a.Year == vYear);

        setFilteredSettings({ ...settings, groups: fGroups, models: [], productModels: [] });
        setGroupData(fGroups);

    };


    useEffect(() => {


        // && filteredSettings?.groups?.length == 0
        if (settings?.brands && settings?.brands.length > 0 && Defult?.first != true
        ) {

            if (Defult?.year) {
                setYear(Defult?.year)
                const val = { ...requestForm };
                val.year = Defult?.year;
                setRequestForm(val);
            }

            if (Defult?.brand)
                handelSelectBrand(Defult?.brand, Defult?.year);
        }

    }, [Defult, settings]);

    const [fullDatetime, setFullDatetime] = useState(null);
    useEffect(() => {

        try {

            if (requestForm?.date) {

                var md = new Date(requestForm?.date);
                try {
                    if (requestForm?.time) {

                        var Hours = requestForm?.time.split(":");

                        md.setHours(Hours[0], Hours[1], 0);
                    }
                } catch (error) {

                }

                // var datetime =  new moment(md).format('yyyy-MM-DD HH:mm:ss')
                var datetime = md.toLocaleDateString("en-GB", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).replaceAll(',', '').replaceAll('/', '-');
                setFullDatetime(datetime);
                //console.log();
            }

        } catch (error) {
        }


    }, [requestForm]);

    useEffect(() => {
        if (settings?.brands && settings?.brands.length > 0 && filteredSettings?.groups?.length > 0 && Defult?.first != true) {

            setDefult({ ...Defult, first: true });
            if (Defult?.group)
                handleFilteredModels(Defult?.group);
            // if (Defult?.year) {
            //     setYear(Defult?.year)
            //     const val = { ...requestForm };
            //     val.year = Defult?.year;
            //     setRequestForm(val);
            // }

            if (Defult?.modelType) {
                setType(Defult?.modelType);
            }
        }
    }, [filteredSettings]);


    useEffect(() => {
        getMainUserData();
    }, []);
    const getMainUserData = async () => {
        let data = {};

        try {
            data = JSON.parse(getData(User_Data_Key, true));
        } catch (error) {

        }
        try {

            if (getData('isAuthenticated'))
                setLogin(true);
        } catch (err) {
            //////console.log(err);
            setLogin(false);
        }



        return data;
    };

    const fetchSettings = async () => {


        //console.log("fetchSettings:>>>>>>>>>>>>>>>>>>>:", settings);
        if (settings?.brands.length <= 0) {

            try {

                if ("caches" in window) {
                    var curl = "Settings-" + lang;

                    // Opening that particular cache
                    const cacheStorage = await caches.open("HJWeb");

                    // Fetching that particular cache data
                    const cachedResponse = await cacheStorage.match(
                        curl
                    );
                    var settingResponseCash = await cachedResponse?.json();

                    const currentSettings = { ...settings };
                    currentSettings.brands = settingResponseCash?.brands;
                    currentSettings.groups = settingResponseCash?.groups;
                    currentSettings.models = settingResponseCash?.models;
                    currentSettings.productModels = settingResponseCash?.productModels;
                    setSettings(currentSettings);

                    const fGroups = currentSettings?.groups?.filter(a => a.brandID == brand);
                    setGroupData(fGroups);
                    //---------------------------------------------------------------
                    let currentvModelCode = {};
                    currentSettings?.productModels?.map((item) => {
                        if (item.ModelCode) {
                            currentvModelCode[item.productGroupID] = item.ModelCode;
                        }
                    })
                    setVModelCode(currentvModelCode);
                }


                const settingResponse = await axios.request({
                    baseURL: '/',
                    url: config.controllURL + lang + "/api/Maintenance/Settings",
                    method: "get"
                });

                const currentSettings = { ...settings };
                currentSettings.brands = settingResponse.data?.brands;
                currentSettings.groups = settingResponse.data?.groups;
                currentSettings.models = settingResponse.data?.models;
                currentSettings.productModels = settingResponse.data?.productModels;

                setSettings(currentSettings);

                const fGroups = currentSettings?.groups?.filter(a => a.brandID == brand);
                setGroupData(fGroups);
                //---------------------------------------------------------------

                let currentvModelCode = {};
                currentSettings?.productModels?.map((item) => {
                    currentvModelCode[item.productGroupID] = item.ModelCode

                })

                //////console.log("currentvModelCode>>>>>>>>>", currentvModelCode);
                setVModelCode(currentvModelCode);

                const data = new Response(JSON.stringify(settingResponse.data));

                if ("caches" in window) {
                    // Opening given cache and putting our data into it
                    caches.open("HJWeb").then((cache) => {
                        cache.put("Settings-" + lang, data);

                    });
                }

            } catch (error) {
                //////console.log(error);
            }

        }


    };


    const handleServiceOrder = useCallback(async (data) => {

        try {
            data['firstFetchPrice'] = null;
            data['first'] = null;

            setActiveVehicleTab('myCars');


            var serviceOptions = data.serviceOptions;
            var objectservicesJON = {};
            if (serviceOptions && serviceOptions.length > 0 && data.sub2) {
                objectservicesJON[`${data.sub2}`] = serviceOptions;
                setServiceDataJson(objectservicesJON);
            }
            setSerciveID(null);

            setRequestForm({
                lastName: null,
                firstName: null,
                phone: null,
                email: null,
                subject: null,
                date: null,
                time: null,
                messageContent: null,
                myCarID: null,
            });

            setStepNum(1);
            setDataFullNum(0);

            setselsub0({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
            setService([]);
            setinfoPrice([{ Price: 0 }]);

            var value = { ...maintenanceObj, ...data };
            if (data?.main == '') {

                data['main'] = null;
            }
            if (data?.sub1 == '') {

                data['sub1'] = null;
            }
            if (data?.sub2 == '') {

                data['sub2'] = null;


            }

            setMainServiceID(data?.main);
            setSubServiceID(data?.sub1);
            setTypeServiceID(data?.sub2);
            setDefult(data);

            if (getData('isAuthenticated') && data?.modelType == null) {
                GetVehicales();

            } else {

                fetchSettings();
            }

            fetchMainService(data);
            GetBranch();

            setSubService1([]);
            setSubService2([]);
            setService([]);

            if (value.type === "order") {

                setselMain({ ID: "0", desAr: "اختيار قيمة", desEn: "chose" });
                setselsub1({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
                setselsub2({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });

            }
            setTimeout(() => {
                if (value.type === 'main') {
                    var main = { value: data.main, sub1: data.sub1 }
                    fetchSubService(data);
                    setselsub2({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });

                } else if (value.type === 'sub1') {
                    var main = { value: data.main }
                    fetchSubService(data);
                    var sub1 = { value: data.sub1, ServiceID: data?.ServiceID }
                    fetchSubService2(data);

                } else if (value.type == 'sub2') {

                    var main = { value: data.main }
                    fetchSubService(data);
                    var sub1 = { value: data.sub1, ServiceID: data?.ServiceID }
                    fetchSubService2(data, objectservicesJON);
                    var sub2 = { value: data.sub2, ServiceID: data?.ServiceID }

                    fetchService(sub2, null, objectservicesJON);


                }
                setTimeout(() => { setMaintenanceObj(value) }, 1000);

            }, 0, [ServicesDataJson]);
        } catch (e) {
            console.error(e)

        }






    }, [ServicesDataJson]);
    const [Note, setNote] = useState("");

    const [MainServic, setMainServic] = useState([]);
    async function fetchMainService(opiton) {


        if (MainServic.length <= 0) {


            try {
                if ("caches" in window) {
                    var curl = "site_fetchMainService_Req";

                    // Opening that particular cache
                    const cacheStorage = await caches.open("HJWeb");

                    // Fetching that particular cache data
                    const cachedResponse = await cacheStorage.match(
                        curl
                    );
                    var datacash = await cachedResponse?.json();
                    if (datacash && datacash?.length > 0) {

                        setTimeout(setMainServic(datacash), 1000);
                        if (opiton.main)
                            datacash?.map((B) => {
                                if (B.MainServiceID === opiton.main) {
                                    const v = selMain;
                                    v.desAr = B.DescriptionAr;
                                    v.desEn = B.DescriptionEn;
                                    v.ID = B.MainServiceID;
                                    // setselMain(v);
                                    ////////console.log(v);
                                }
                            })
                    }



                }
            } catch (error) {

            }

            const Body = {}

            axios.request({
                url: `${config.controllURL}${lang}/api/Pages/site_fetchMainService_Req`,
                data: Body, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    // //////console.log(response.data.ApiObjectData);
                    setTimeout(setMainServic(response.data), 1000);
                    if (opiton.main)
                        response.data.map((B) => {
                            if (B.MainServiceID === opiton.main) {
                                const v = selMain;
                                v.desAr = B.DescriptionAr;
                                v.desEn = B.DescriptionEn;
                                v.ID = B.MainServiceID;
                                // setselMain(v);
                                ////////console.log(v);
                            }
                        })

                    const data = new Response(JSON.stringify(response.data));

                    if ("caches" in window) {
                        // Opening given cache and putting our data into it
                        caches.open("HJWeb").then((cache) => {
                            cache.put("site_fetchMainService_Req", data);

                        });
                    }


                })
                .catch(function (error) {
                    //////console.log(error);
                });


        }
    }
    const [SubService1, setSubService1] = useState([]);
    async function fetchSubService(option) {


        setselsub1({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
        setselsub2({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
        setselsub0({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
        setSubService1([]);
        setSubService2([]);
        setService([]);
        setinfoPrice([{ Price: 0 }]);
        var SID = option.main ? option.main : option.value;

        // if (SID != Body_PaintingGUID) {


        if ("caches" in window) {
            var curl = "site_fetchMntc_SubService1-" + SID;

            // Opening that particular cache
            const cacheStorage = await caches.open("HJWeb");

            // Fetching that particular cache data
            const cachedResponse = await cacheStorage.match(
                curl
            );
            var settingResponseCash = await cachedResponse?.json();

            if (settingResponseCash && settingResponseCash?.length > 0) {
                setTimeout(setSubService1(settingResponseCash), 1000);

                if (settingResponseCash.length == 1
                    //  || SID == Body_PaintingGUID
                ) {

                    ////console.log("settingResponseCash>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>:", settingResponseCash);
                    if (SID == Body_PaintingGUID && settingResponseCash && settingResponseCash[1]) {
                        // setFirestOptionService1(settingResponseCash[0])
                    } else {

                        setFirestOptionService1(settingResponseCash[0])
                    }
                }
                if (option.sub1)
                    settingResponseCash?.map((B) => {
                        if (B.SubService1ID === option.sub1) {
                            const v = selsub1;
                            v.desAr = B.DescriptionAr;
                            v.desEn = B.DescriptionEn;
                            v.ID = B.SubService1ID;
                            setselsub1(v);

                        }
                    }
                    )
            }



        }

        const Body = {
            "MainID": option.main ? option.main : option.value
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_fetchMntc_SubService1`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // //////console.log(response.data.ApiObjectData);
                setTimeout(setSubService1(response.data), 1000);

                if (response?.data.length == 1
                    // || SID == Body_PaintingGUID
                ) {

                    if (SID == Body_PaintingGUID) {
                        // setFirestOptionService1(response?.data[0])
                    } else {

                        setFirestOptionService1(response?.data[0])
                    }
                }
                if (option.sub1)
                    response.data.map((B) => {
                        if (B.SubService1ID === option.sub1) {
                            const v = selsub1;
                            v.desAr = B.DescriptionAr;
                            v.desEn = B.DescriptionEn;
                            v.ID = B.SubService1ID;
                            setselsub1(v);

                        }
                    }
                    )


                const data = new Response(JSON.stringify(response.data));

                if ("caches" in window) {
                    // Opening given cache and putting our data into it
                    caches.open("HJWeb").then((cache) => {
                        cache.put("site_fetchMntc_SubService1-" + SID, data);

                    });
                }



            })
            .catch(function (error) {
                //////console.log(error);
            });


        // }
    }
    const [SubService2, setSubService2] = useState([]);
    async function fetchSubService2(option, objectservicesJON) {


        setselsub2({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
        setselsub0({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
        setSubService2([]);
        setService([]);
        setinfoPrice([{ Price: 0 }]);

        var getFirestOption = false;

        var SID = option.sub1 ? option.sub1 : option.value;

        //////console.log("fetchSubService2PPPPPPPPPPPPPPPPPPPPPPPPPP?",SID);
        if ("caches" in window) {
            var curl = "site_fetchMntc_SubService2-" + SID;

            // Opening that particular cache
            const cacheStorage = await caches.open("HJWeb");

            // Fetching that particular cache data
            const cachedResponse = await cacheStorage.match(
                curl
            );
            var settingResponseCash = await cachedResponse?.json();

            if (settingResponseCash && settingResponseCash?.length > 0) {
                setTimeout(setSubService2(settingResponseCash), 100);

                const NewDynamicOption = DynamicOptions[SID];

                if (settingResponseCash?.length == 1 || (NewDynamicOption != null && NewDynamicOption != undefined && NewDynamicOption != "")
                ) {
                    getFirestOption = true;


                    if (NewDynamicOption != null && NewDynamicOption != undefined && NewDynamicOption != "") {
                        setFirestOption(settingResponseCash.filter(c => c.SubService2ID == NewDynamicOption)[0], SID, option?.SerciveID, objectservicesJON)

                    } else {

                        setFirestOption(settingResponseCash[0], SID, option?.SerciveID, objectservicesJON)
                    }
                }

                if (option.sub2)
                    settingResponseCash?.map((B) => {
                        if (B.SubService2ID === option.sub2) {
                            const v = selsub2;
                            v.desAr = B.DescriptionAr;
                            v.desEn = B.DescriptionEn;
                            v.ID = B.SubService2ID;
                            setselsub2(v);
                            ////////console.log(v);
                        }
                    })
            }



        }
        const Body = {
            "SubID": option.sub1 ? option.sub1 : option.value
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/site_fetchMntc_SubService2`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {

                setTimeout(setSubService2(response.data), 100);

                const NewDynamicOption = DynamicOptions[SID];

                if (response?.data.length == 1 || (NewDynamicOption != null && NewDynamicOption != undefined && NewDynamicOption != "")
                ) {

                    if (getFirestOption == false) {


                        if (NewDynamicOption != null && NewDynamicOption != undefined && NewDynamicOption != "") {
                            setFirestOption(response?.data?.filter(c => c.SubService2ID == NewDynamicOption)[0], SID, option?.SerciveID, objectservicesJON)
                        } else {

                            setFirestOption(response?.data[0], SID, option?.SerciveID, objectservicesJON)
                        }

                    }

                }

                if (option.sub2)
                    response.data.map((B) => {
                        if (B.SubService2ID === option.sub2) {
                            const v = selsub2;
                            v.desAr = B.DescriptionAr;
                            v.desEn = B.DescriptionEn;
                            v.ID = B.SubService2ID;
                            setselsub2(v);
                            ////////console.log(v);
                        }
                    })

                const data = new Response(JSON.stringify(response.data));

                if ("caches" in window) {
                    // Opening given cache and putting our data into it
                    caches.open("HJWeb").then((cache) => {
                        cache.put("site_fetchMntc_SubService2-" + SID, data);

                    });
                }

            })
            .catch(function (error) {
                //////console.log(error);
            });



    }

    const [Service, setService] = useState([]);
    const [lodingService, setLodingService] = useState(false);
    async function fetchService(option, subServiceID, objectservicesJON = ServicesDataJson) {
        setselsub0({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
        setService([]);
        setinfoPrice([{ Price: 0 }]);

        setLodingService(true);

        if (objectservicesJON[option.value]) {

            var responseData = objectservicesJON[option.value];
            setTimeout(setService(responseData), 1000);
            if (responseData.length == 1 || subServiceID == CheckingGUID || subServiceID == PaintingGUID
                || subServiceID == GeneralRepairGUID) {
                setSerciveID(responseData[0].ServiceID);
                const val = { ...requestForm };
                val.SerciveID = responseData[0].ServiceID;
                setRequestForm(val);

            }

            if (option?.ServiceID) {
                setSerciveID(option?.ServiceID)
                const val = { ...requestForm };
                val.SerciveID = option?.ServiceID;
                setRequestForm(val);
                responseData.map((B) => {
                    if (B.ServiceID === option?.ServiceID) {
                        const v = selsub0;
                        v.desAr = B.ServiceNameAR;
                        v.desEn = B.ServiceName;
                        v.ID = B.ServiceID;
                        setselsub0(v);
                        ////////console.log(v);
                    }
                })
            }


            setLodingService(false);
        } else {

            // //console.log("site_FetchServices",modelCode ?? null);
            const Body = {
                "GUID": option.value,
                // "ModelCode": null
                "ModelCode": modelCode ?? null
            }

            axios.request({
                url: `${config.controllURL}${lang}/api/Pages/site_FetchServices`,
                data: Body, method: "POST", responseType: "json"
            })
                .then(function (response) {
                    // //////console.log(response.data.ApiObjectData);
                    setTimeout(setService(response.data), 1000);
                    if (response?.data.length == 1 || subServiceID == CheckingGUID || subServiceID == PaintingGUID
                        || subServiceID == GeneralRepairGUID) {

                        setSerciveID(response?.data[0].ServiceID);

                        const val = { ...requestForm };
                        val.SerciveID = response?.data[0].ServiceID;
                        setRequestForm(val);
                        ////console.log("response?.data[0]?>>>>>>>>>>>>>>>>>>>>>>>>>>", response?.data[0])
                        //console.log("setRequestForm?>>>>>>>>>>>>>>>>>>>>>>>>>>", val)
                    }

                    if (option?.ServiceID) {
                        setSerciveID(option?.ServiceID)
                        const val = { ...requestForm };
                        val.SerciveID = option?.ServiceID;
                        setRequestForm(val);
                        response.data.map((B) => {
                            if (B.ServiceID === option?.ServiceID) {
                                const v = selsub0;
                                v.desAr = B.ServiceNameAR;
                                v.desEn = B.ServiceName;
                                v.ID = B.ServiceID;
                                setselsub0(v);
                                ////////console.log(v);
                            }
                        })
                    }


                    setLodingService(false);

                })
                .catch(function (error) {

                    setLodingService(false);
                    //////console.log(error);
                });

        }

    }
    const [Branches, setBranches] = useState([]);

    let [modelCode, setModelCode] = useState("");
    let [VIN, setVIN] = useState("");

    const [SerciveID, setSerciveID] = useState(null);
    const [MainServiceID, setMainServiceID] = useState(null);
    const [subServiceID, setSubServiceID] = useState(null);
    const [TypeServiceID, setTypeServiceID] = useState(null);
    async function FetchPrice(modelC, SID) {

        ////console.log("FetchPrice>>>>>>>>>:", modelC)
        setinfoPrice([{ Price: 0 }]);
        if (!modelC) {
            return;
        }
        if (!SID) return;



        const Body = {
            "ModelCode": modelC,
            "ServicID": SID
        }

        axios.request({
            url: `${config.controllURL}${lang}/api/Pages/Site_fetchPriceService`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                // //////console.log(response.data.ApiObjectData);

                setinfoPrice(response.data);

            })
            .catch(function (error) {
                setinfoPrice([{ Price: 0 }]);

                //////console.log(error);
            });


    }

    const checkDataFullNum = async () => {

        if (SerciveID == "999999999" && (requestForm?.CustomKM == null || requestForm?.CustomKM == "")) {
            setDataFullNum(0);
            return 0;
        }
        if (((isLogin && requestForm?.VIN) || type) && SerciveID && requestForm?.date && requestForm?.time && requestForm?.SiteID && (isLogin || (requestForm?.firstName && requestForm?.lastName && requestForm?.phone))) {
            setDataFullNum(2);
            return 2;
        } else if (((isLogin && requestForm?.VIN) || type) && SerciveID) {
            setDataFullNum(1);
            return 2;
        } else {
            setDataFullNum(0);
            return 0;
        }


    }

    const checkErrors = () => {
        var thisSchema = null;

        if (isLogin) {

            thisSchema = LoginSchema;
        } else {
            thisSchema = notLoginSchema;

        }
        const result = formValidate(thisSchema, requestForm) ?? {};

        ////console.log("formValidate>>>>>>>>>>>>>>:", result);
        setError(result);


    }
    const [error, setError] = useState({});
    function SendResreve(VIN, ServecID, UserID, Amount) {

        var thisSchema = null;

        if (isLogin) {

            thisSchema = LoginSchema;
        } else {
            thisSchema = notLoginSchema;

        }
        const val = { ...requestForm };
        val.year = year;
        setRequestForm(val);
        const result = formValidate(thisSchema, val) ?? {};
        var newNote = Note;

        var serviceIDKM = ServecID;
        if (ServecID == "999999999") {
            serviceIDKM = Service && Service.length > 0 ? Service[Service.length - 1]["ServiceID"] : "999999999";

            if (requestForm.CustomKM == null || requestForm.CustomKM == "") {
                result["CustomKM"] = trans("messages:field_required");

            } else {
                delete result["CustomKM"];
                newNote = "( صيانة مخصصة :" + requestForm.CustomKM + ") " + newNote;
            }
        }



        setError(result);
        if (Object.keys(result).length == 0 && isSendeng == false) {

            setIsSendeng(true);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = {
                "VIN": VIN,
                "Model": type,
                "CarType": modelCode,
                "UserID": UserID ?? "",
                "Year": year,
                "TotalAmount": Amount ? Amount : 0,
                "RequiredServicesList": serviceIDKM,
                "Note": newNote,
                "MeterReading": requestForm?.meterReading,
                "FirstName": requestForm?.firstName,
                "LastName": requestForm?.lastName,
                "phone": requestForm?.phone,
                "StoreID": requestForm?.SiteID,
                "Email": requestForm?.email,
                "Orderdate": moment(requestForm?.date).format('YYYY-MM-DD'),
                "OrderTime": moment(requestForm?.time).format('HH:mm:ss'),
                "CopyformFile": requestForm?.file
            };

            // console.log("raw", raw);
            // setIsSendeng(false);
            // return
            axios.request({
                url: config.controllURL + "api/Service/ServiceRequestAdd", headers: myHeaders,
                data: raw, method: "POST", responseType: "json"
            }).then(function (response) {
                //////console.log("Service", response.data)

                //--------------------------------
                journifyTrackingCarEvents.trackGenerateLead(Amount ?? 0);
                //------------------------------

                setStepNum(1);
                setDataFullNum(0);

                setSerciveID(null);
                setselsub0({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
                setService([]);
                setinfoPrice([{ Price: 0 }]);

                setRequestForm({
                    lastName: '',
                    firstName: '',
                    phone: '',
                    email: '',
                    subject: '',
                    date: '',
                    time: '',
                    messageContent: '',
                    myCarID: '',
                    SiteID: null,
                });

                setMaintenanceObj({
                    showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
                });
                //console.log("OrderID", response?.data)
                if (response?.data?.OrderID)
                    setResOrderID(response?.data?.OrderID);
                setShowFinalPopup(true);
                toast.success(trans("info:reservation_completed_successfully"));

            }
            ).then((response) => {
                //////console.log('Error', response);
                setIsSendeng(false);
            })
                .catch(error => {
                    //////console.log('error', error);
                    setIsSendeng(false);
                }



                );

        }
    }



    async function GetBranch() {
        if (Branches.length <= 0) {

            const Body = {};

            await axios.request({
                url: `${config.controllURL}${lang}/api/Pages/site_FetchMaintenanceBranches`,
                data: Body, method: "POST", responseType: "json"
            })
                .then(function (response) {

                    setBranches(response.data);


                })
                .catch(function (error) {
                    //////console.log(error);
                });
        }



    }

    useEffect(() => {
        if (Branches && Branches?.length > 0 && requestForm?.SerciveID && requestForm?.SerciveID != '' && !requestForm?.SiteID) {


            if (Branches?.length == 1) {
                const val = { ...requestForm };
                val.SiteID = Branches[0]?.SiteID;
                setRequestForm(val);
            }

        }

    }, [Branches, requestForm]);

    const [Vehicales, setVehicales] = useState([]);
    const [userData, setUserData] = useState(null);

    async function GetVehicales() {
        try {
            const isLogin = getData('isAuthenticated')
            if (!isLogin) {
                setVehicales([]);
                return;
            }

            const cleanData = JSON.parse(getData(User_Data_Key, true));
            var _userID = cleanData?.id?.toString().split('_')[1];

            if (Vehicales && (Vehicales.length <= 0 || (userData && userData.id != cleanData.id))) {
                setUserData(cleanData);
                if (!_userID) {
                    setVehicales([]);
                    return;
                }

                const Body = {
                    "userID": Number(_userID)
                };
                await axios.request({
                    url: `${config.controllURL}${lang}/api/Pages/SiteGetUserCars`,
                    data: Body, method: "POST", responseType: "json"
                })
                    .then(function (response) {
                        setVehicales(response.data);
                    })
                    .catch(function (error) {
                        console.error(error);
                    });

            }
        } catch (error) {
            console.error(error);
        }
    }
    //selected option 
    const [selMain, setselMain] = useState({ ID: "0", desAr: "اختيار قيمة", desEn: "chose" });
    const [selsub1, setselsub1] = useState({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
    const [selsub2, setselsub2] = useState({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
    const [selsub0, setselsub0] = useState({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });


    function setFirestOption(option, SID, currentServiceID = SerciveID, objectservicesJON = ServicesDataJson) {
        fetchService({ value: option.SubService2ID, text: lang === 'ar' ? option.DescriptionAr : option.DescriptionEn, currentServiceID }, SID, objectservicesJON);

        setTypeServiceID(option.SubService2ID);
    }


    function setFirestOptionService1(option) {
        fetchSubService2({ value: option.SubService1ID, text: lang === 'ar' ? option.DescriptionAr : option.DescriptionEn });
        setSubServiceID(option.SubService1ID);
    }


    function setFirestOptionService(option) {
        setSerciveID(option.ServiceID);
    }

    useEffect(() => {
        checkDataFullNum();
    }, [requestForm, SerciveID, year, type, isLogin]);



    useEffect(() => {
        if (vModelCode != null && SerciveID && Defult?.firstFetchPrice != true) {
            setDefult({ ...Defult, firstFetchPrice: true });
            if (Defult?.modelType) {
                if (vModelCode[Defult?.modelType] && SerciveID)
                    FetchPrice(vModelCode[Defult?.modelType], SerciveID);
            }



        }

    }, [vModelCode, SerciveID]);

    const [seoPageInfo, setSeoPageInfo] = useState({});
    useEffect(() => {
        async function fetchSeo() {
            try {
                const response = await axios.post(
                    `${config.controllURL}${lang}/api/Pages/SiteFetchSeoPages`,
                    { page: "maintenance services" }
                );
                if (response.status === 200 && response.data?.[0]) {
                    setSeoPageInfo(response.data[0]);
                }
            } catch (e) {
                console.warn("SEO info unavailable:", e?.message);
            }
        }
        fetchSeo();
    }, []);

    const [listTimeAvailable, setListTimeAvailable] = useState([]);
    // const [maxTime, setMaxTime] = useState(0);
    // const [minTime, setMinTime] = useState(0);

    const webAvailableReshours = async (date = '', serviceGuid = null) => {
        const Body = {
            "Resdate": date,
            "ServiceGuid": serviceGuid
        }

        await axios.request({
            url: `${config.controllURL}${lang}/api/Pages/web_AvailableReshours`,
            data: Body, method: "POST", responseType: "json"
        })
            .then(function (response) {
                //console.log("web_AvailableReshours:response", response);
                if (response.status >= 200 && response.status < 299) {
                    //console.log("web_AvailableReshours:response", response.statusText);
                    if (response?.data && response?.data.length != 0) {
                        response?.data.forEach((val, index) => {

                            setListTimeAvailable(_lstTime => [..._lstTime, parseInt(val?.AvailableHour)]);
                        });

                    }
                }
            })
            .catch(function (error) {
                //console.log("web_AvailableReshours:Error", error);
                toast.warn(trans("form:please-choose-another-date"));
            });
    }

    // useEffect(() => {
    //
    //     debugger
    //     setMaxTime(Math.max(...listTimeAvailable));
    //     //console.log("setMaxTime(Math.max(...listTimeAvailable))", setMaxTime(Math.max(...listTimeAvailable)));
    //     setMinTime(Math.min(...listTimeAvailable));
    //     //console.log("setMaxTime(Math.min(...listTimeAvailable))", setMaxTime(Math.min(...listTimeAvailable)));
    //
    // }, [listTimeAvailable]);

    const maxTime = Math.max(...listTimeAvailable);
    const minTime = Math.min(...listTimeAvailable);




    return (
        <>
            <Popup show={maintenanceObj.showPopup}>
                <div className="mainteance-popup nice-flex nice-flex-center">
                    <div className="mainteance-popup-container p-4">
                        <div className="mainteance-popup-container-header">
                            <h1 className="text-balck text-bold text-24 text-center">{trans("info:request-maintenance-service")}</h1>
                            <span className='mainteance-popup-container-header-close text-block text-gray' onClick={() => {
                                setMaintenanceObj({ showPopup: false })
                            }}>&times;</span>


                        </div>

                        <div className="customStepper">
                            <div className={"customStepper-part " + (dataFullNum > 0 ? "active" : " ")}>
                                {/* <span className="customStepper-part-titel"><li>{"1"}</li>{'بيانات المركبة'}</span> */}
                                <div className={"customStepper-part-connector  "}></div>
                            </div>
                            <div className={"customStepper-part " + (dataFullNum > 1 ? "active" : " ")}>
                                {/* <span className="customStepper-part-titel"><li>{"2"}</li>{'بيانات الخدمة'}</span> */}
                                <div className={"customStepper-part-connector  "}></div>
                            </div>

                            {/* <div className={"customStepper-part " + (dataFullNum > 2 ? "active" : " ")}>
                                <span className="customStepper-part-titel"><li>{"3"}</li>{'البيانات الشخصية'}</span>
                                <div className={"customStepper-part-connector  "}></div>
                            </div> */}

                        </div>
                        <div className="ruler-2 mb-3"></div>
                        <div className="my-8 px-8 flex flex-col nice-gap-3rem mainteance-popup-container-body">







                            {
                                stepNum == 1 &&
                                <>

                                    {
                                        isLogin && (
                                            <div className="model-selector-tabs mb-6" style={{ maxWidth: '100%', background: 'transparent', padding: 0 }}>
                                                <Swiper
                                                    slidesPerView={"auto"}
                                                    spaceBetween={12}
                                                    centerInsufficientSlides={true}
                                                    className="tabs-swiper"
                                                    style={{ padding: '8px 0' }}
                                                >
                                                    <SwiperSlide style={{ width: 'auto' }}>
                                                        <div
                                                            className={`model-chip ${activeVehicleTab === 'myCars' ? 'selected' : ''}`}
                                                            onClick={() => setActiveVehicleTab('myCars')}
                                                            style={{ whiteSpace: 'nowrap' }}
                                                        >
                                                            <div className="chip-check">
                                                                <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="4"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                            </div>
                                                            <span className="chip-label">{trans("info:reserve_for_my_vehicle")}</span>
                                                        </div>
                                                    </SwiperSlide>

                                                    <SwiperSlide style={{ width: 'auto' }}>
                                                        <div
                                                            className={`model-chip ${activeVehicleTab === 'newCar' ? 'selected' : ''}`}
                                                            onClick={() => {
                                                                setActiveVehicleTab('newCar');
                                                                fetchSettings();
                                                            }}
                                                            style={{ whiteSpace: 'nowrap' }}
                                                        >
                                                            <div className="chip-check">
                                                                <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" strokeWidth="4"><polyline points="20 6 9 17 4 12"></polyline></svg>
                                                            </div>
                                                            <span className="chip-label">{trans("info:reserve_for_another_vehicle")}</span>
                                                        </div>
                                                    </SwiperSlide>
                                                </Swiper>
                                            </div>
                                        )
                                    }

                                    {
                                        (!isLogin || Defult?.modelType || activeVehicleTab === 'newCar') ?
                                            <>



                                                <div className="flex flex-row grid-2-cols nice-gap-2rem ">
                                                    <div className="basis2/4 grow">
                                                        <DropDownInput

                                                            defaultOption={(brand == '0' || brand == null) ? { text: trans("info:company"), value: '0' } : null}
                                                            options={settings?.brands?.map(item => {
                                                                return { text: item?.description, value: item?.brandID }
                                                            })}
                                                            placeholder={trans("info:company")}
                                                            selectedValue={brand}
                                                            onSelect={handelSelectBrand}
                                                        />
                                                    </div>

                                                    <div className="basis2/4 grow">
                                                        <DropDownInput
                                                            errorLabel={error?.year}
                                                            defaultOption={{
                                                                text: trans("info:created_year"),
                                                                value: '0'
                                                            }}
                                                            placeholder={trans("info:created_year")}
                                                            // options={settings?.models?.map(item => {
                                                            //     return { text: item?.modelID, value: item?.modelID }
                                                            // })}

                                                            options={
                                                                settings?.models?.filter(
                                                                    item => item?.modelID?.startsWith('20')).map(
                                                                        item => ({
                                                                            text: item?.modelID,
                                                                            value: item?.modelID
                                                                        })
                                                                    )
                                                            }

                                                            selectedValue={year}
                                                            onSelect={(value) => {
                                                                //////console.log("models:", value)

                                                                setYear(value);

                                                                const val = { ...requestForm };
                                                                val.year = value;
                                                                setRequestForm(val);
                                                                handelSelectBrand(brand, value);
                                                                // handleFilteredModels(group,value);
                                                            }}
                                                        />
                                                    </div>


                                                </div>

                                                <div className="flex flex-row grid-2-cols nice-gap-2rem ">

                                                    <div className="basis2/4 grow">
                                                        <DropDownInput
                                                            defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                                                text: trans("eparts:vehicle"),
                                                                value: '0'
                                                            } : null}
                                                            placeholder={trans("eparts:vehicle")}
                                                            options={filteredSettings?.groups?.map(item => {
                                                                return { text: item?.description, value: item?.productGroupID }
                                                            })}
                                                            selectedValue={group}
                                                            onSelect={handleFilteredModels}
                                                        />
                                                    </div>
                                                    <div className="basis2/4 grow">
                                                        <DropDownInput

                                                            defaultOption={((brand == '0' || brand == null) || (group == '0' || group == null)) ? {
                                                                text: trans("eparts:model"),
                                                                value: '0'
                                                            } : null}
                                                            placeholder={trans("eparts:model")}
                                                            errorLabel={requestForm?.type}
                                                            options={filteredSettings?.productModels?.map(item => {
                                                                return { text: item?.ShortDescriptionEn, value: item?.productTypeID }
                                                            })}
                                                            selectedValue={type}
                                                            onSelect={(value) => {
                                                                //////console.log("setType:", value)
                                                                setType(value);
                                                                //////console.log("vModelCode[value]:", vModelCode[value])
                                                                setModelCode(vModelCode[value]);
                                                                FetchPrice(vModelCode[value], SerciveID);

                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </>
                                            :
                                            <div className="vehicle-selection-wrapper">
                                                {Vehicales.length > 0 ? (
                                                    <DropDownInput
                                                        title={trans("info:Vehicle-must-be-selected")}
                                                        errorLabel={error?.VIN}
                                                        selectedValue={requestForm?.VIN}
                                                        options={[
                                                            ...Vehicales.map(B => {
                                                                const modelTrans = lang == 'ar' ? 'Ar' : 'En';
                                                                const brandTrans = lang == 'ar' ? 'Ar' : 'En';
                                                                const carName = B[`ModelDescription${modelTrans}`] || B[`GroupDescription${modelTrans}`] || B.carAr || B.carEn;
                                                                const brandName = B[`BrandDescription${brandTrans}`] || "";
                                                                return {
                                                                    value: B.CarID || B.SN,
                                                                    text: `${brandName} ${carName}`.trim(),
                                                                    ModelCode: B.ModelCode,
                                                                    year: B.Model,
                                                                    type: B.Type || B.CarID
                                                                };
                                                            })]}
                                                        onfilter={(option) => {
                                                            setModelCode(option.ModelCode);
                                                            setVIN(option.value);
                                                            setYear(option.year);
                                                            setType(option.type);
                                                            FetchPrice(option.ModelCode, SerciveID);

                                                            const val = { ...requestForm };
                                                            val.VIN = option.value;
                                                            setRequestForm(val);
                                                        }}
                                                        isepart={true}
                                                    />
                                                ) : (
                                                    <div className="text-center py-4 text-gray text-18">
                                                        {isLogin ? trans("info:loading_vehicles") : trans("info:login_to_see_vehicles")}
                                                    </div>
                                                )}
                                            </div>
                                    }

                                    {


                                        <div className="flex flex-row grid-3-cols nice-gap-3rem ">
                                            <DropDownInput
                                                options={[
                                                    ...MainServic.map(B => {
                                                        return { value: B.MainServiceID, text: lang === 'ar' ? B.DescriptionAr : B.DescriptionEn };
                                                    })]}
                                                onfilter={(option) => {
                                                    setMainServiceID(null);
                                                    setSubServiceID(null);
                                                    setTypeServiceID(null);
                                                    setSerciveID(null);
                                                    fetchSubService(option);
                                                    setMainServiceID(option.value);
                                                }
                                                }
                                                defaultOption={{ value: selMain.ID, text: trans("info:main_service") }}
                                                selectedValue={MainServiceID}
                                                isepart={true}
                                            />

                                            {
                                                (SubService1?.length > 1
                                                    // && MainServiceID != Body_PaintingGUID
                                                ) ?

                                                    <DropDownInput

                                                        options={[
                                                            ...SubService1.map(B => {

                                                                return ({ value: B.SubService1ID, text: lang === 'ar' ? (B.DescriptionAr ? B.DescriptionAr : B.DescriptionEn) : B.DescriptionEn });


                                                            })]}
                                                        onfilter={async (option) => {
                                                            setSubServiceID(null);
                                                            setTypeServiceID(null);
                                                            setSerciveID(null);
                                                            fetchSubService2(option);
                                                            setSubServiceID(option.value);

                                                            if (requestForm.date) {
                                                                const selectedDate = moment(requestForm.date).format('yyyy-MM-DD');
                                                                const isToday = selectedDate === moment().format('yyyy-MM-DD');
                                                                const hasRestricted = option.value?.toUpperCase() !== PERIODIC_MAINTENANCE_ID;

                                                                if (isToday && hasRestricted) {
                                                                    setWarningPopup({
                                                                        show: true,
                                                                        message: lang === 'ar'
                                                                            ? "هذه الخدمة لا يمكن حجزها في نفس اليوم، يرجى اختيار تاريخ آخر (ابتداءً من الغد)."
                                                                            : "This service cannot be booked on same day, please choose another date (starting from tomorrow)."
                                                                    });
                                                                    const val = { ...requestForm };
                                                                    val.date = null;
                                                                    val.time = null;
                                                                    setRequestForm(val);
                                                                    setListTimeAvailable([]);
                                                                } else {
                                                                    await webAvailableReshours(selectedDate, option.value);
                                                                }
                                                            }
                                                        }}
                                                        isepart={true}
                                                        selectedValue={subServiceID}
                                                        defaultOption={{ value: selsub1.ID, text: trans("info:sub_main_service") }}
                                                    />
                                                    : null

                                            }


                                            {
                                                (SubService2?.length > 1 && MainServiceID != Body_PaintingGUID && subServiceID != CheckingGUID && subServiceID != GeneralRepairGUID) ?
                                                    <DropDownInput

                                                        options={[
                                                            ...SubService2.map(B => {
                                                                return { value: B.SubService2ID, text: lang === 'ar' ? (B.DescriptionAr ? B.DescriptionAr : B.DescriptionEn) : B.DescriptionEn };
                                                            })]}
                                                        onfilter={(option) => {
                                                            setTypeServiceID(null);
                                                            setSerciveID(null);
                                                            fetchService(option, subServiceID);
                                                            setTypeServiceID(option.value);

                                                        }}

                                                        isepart={true}
                                                        selectedValue={TypeServiceID}
                                                        defaultOption={{ value: selsub2.ID, text: trans("info:main_service_type") }}


                                                    />
                                                    : null


                                            }
                                            {

                                                (MainServiceID != Body_PaintingGUID && subServiceID != CheckingGUID && subServiceID != GeneralRepairGUID) ?
                                                    <DropDownInput
                                                        options={[
                                                            ...Service.map(B => {
                                                                return { value: B.ServiceID, text: lang === 'ar' ? B.ServiceNameAR : B.ServiceName };
                                                            }), { value: "999999999", text: lang === 'ar' ? "اخرى" : "Other" }]}
                                                        errorLabel={error?.SerciveID}
                                                        onfilter={(option) => {

                                                            const val = { ...requestForm };
                                                            val.SerciveID = option.value;
                                                            val.CustomKM = null;
                                                            setRequestForm(val);

                                                            setSerciveID(null);
                                                            setSerciveID(option.value);
                                                            FetchPrice(modelCode, option.value);

                                                        }}
                                                        isepart={true}
                                                        isLoading={lodingService}
                                                        selectedValue={SerciveID ? SerciveID : requestForm?.SerciveID}
                                                        defaultOption={{ value: selsub0.ID, text: trans("info:servce") }}

                                                    />

                                                    :
                                                    null
                                            }


                                            {

                                                (MainServiceID != Body_PaintingGUID && subServiceID != CheckingGUID
                                                    && subServiceID != GeneralRepairGUID
                                                    && SerciveID == "999999999") ?
                                                    <div className="basis2/4 grow">

                                                        <InputField
                                                            errorLabel={error?.CustomKM}
                                                            // moduleLabel={trans("info:كم")}
                                                            // extraClasses={"Input-module"}
                                                            placeholder={trans("info:120,000 كم")}
                                                            type='number'
                                                            value={requestForm?.CustomKM}
                                                            onChangeValue={(e) => {
                                                                const val = { ...requestForm };
                                                                val.CustomKM = e.target.value;
                                                                setRequestForm(val);

                                                            }} />
                                                    </div>

                                                    :
                                                    null
                                            }

                                        </div>


                                    }

                                    <div className="flex flex-row grid-3-cols nice-gap-1rem mb-40">

                                    </div>

                                    {/*السعر */}
                                    {/* { 
                                        // infoPrice[0].Price ?
                                        <div className={""}>
                                            <div className="nice-flex nice-flex-space ">
                                                <p className={`text-16 text-bold my-4 px-3 border-section-${lang == 'en' ? 'left' : 'right'}`}>{trans("info:price")}</p>

                                            </div>

                                            {
                                                <div className="mx-2 mb-5 ">
                                                    <img src='/assets/icons/info.svg' className="mx-3 text-inline-block nice-max-icon" />
                                                    <p className="text-12 text-bold text-gray text-inline-block">{trans("info:service_price_head_message")}</p>
                                                </div>
                                            }
                                            {
                                                <div className='p-4 mt-4 text-30 text-primary'>
                                                    {
                                                        infoPrice[0] && <Price price={infoPrice[0].Price} />
                                                    }

                                                </div>
                                            }
                                        </div>
                                        // : null
                                    } */}

                                </>
                            }

                            {
                                // stepNum == 2 &&
                                <>


                                    {
                                        stepNum == 2 &&
                                        <>
                                            {

                                                !isLogin &&
                                                <>
                                                    <div className="flex flex-row grid-2-cols nice-gap-2rem ">
                                                        <>
                                                            <div className="basis-2/4 grow">

                                                                <InputField

                                                                    errorLabel={error?.firstName}
                                                                    placeholder={trans("form:first-name")}
                                                                    value={requestForm.firstName}
                                                                    length={255}
                                                                    onChangeValue={
                                                                        (e) => {
                                                                            const val = { ...requestForm };
                                                                            val.firstName = e.target.value;
                                                                            setRequestForm(val);
                                                                        }
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                        <>

                                                            <div className="basis-2/4 grow">
                                                                <InputField

                                                                    errorLabel={error?.lastName}
                                                                    placeholder={trans("info:surname")}
                                                                    value={requestForm.lastName}
                                                                    length={255}
                                                                    onChangeValue={
                                                                        (e) => {
                                                                            const val = { ...requestForm };
                                                                            val.lastName = e.target.value;
                                                                            setRequestForm(val);
                                                                        }
                                                                    }
                                                                />
                                                            </div>
                                                        </>
                                                    </div>

                                                    <div className="flex flex-row grid-2-cols nice-gap-2rem ">
                                                        <div className="grow">
                                                            <PhoneDropDown
                                                                title={trans("form:phone")}
                                                                errorLabel={error?.phone}
                                                                value={requestForm.phone}
                                                                onChangeValue={(countryCode, phoneNumber) => {
                                                                    const val = { ...requestForm };
                                                                    val.phone = phoneNumber ? `+${countryCode}${phoneNumber}` : null;
                                                                    val.codephone = `+${countryCode}`;
                                                                    setRequestForm(val);
                                                                }}

                                                                defaultValue={requestForm?.phone?.replace(`${requestForm?.codephone}`, '')}
                                                            />
                                                        </div>

                                                        <div className="grow">
                                                            <InputField

                                                                type='email'
                                                                value={requestForm.email}
                                                                onChangeValue={(e) => {
                                                                    const val = { ...requestForm };
                                                                    val.email = e.target.value;
                                                                    setRequestForm(val);
                                                                }}
                                                                errorLabel={error?.email}
                                                                placeholder={trans("form:email")}
                                                                name='email'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className=" grow">

                                                        <InputField
                                                            errorLabel={error?.VIN}
                                                            placeholder={trans("form:structure-no") + '(VIN)'}
                                                            onChangeValue={(e) => {
                                                                const val = { ...requestForm };
                                                                val.VIN = e.target.value;
                                                                setRequestForm(val);
                                                                setVIN(e.target.value);



                                                            }} />
                                                    </div>


                                                </>
                                            }



                                            <div className="flex flex-row grid-2-cols nice-gap-2rem ">


                                                <div className="grow">
                                                    <div className="basis-2/4 grow">
                                                        <div
                                                            className="w-full flex items-center bg-white border border-gray-200 rounded-lg cursor-pointer hover:border-red-500 transition-all nice-shadow-1"
                                                            style={{ minHeight: '6rem', padding: '0 1.5rem' }}
                                                            onClick={() => setShowCalendar(true)}
                                                        >
                                                            <span className="text-2xl opacity-60 flex-grow">
                                                                {requestForm.date ? moment(requestForm.date).format('YYYY-MM-DD') : trans("form:maintenance-date")}
                                                            </span>
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-red-600">
                                                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                                                <line x1="3" y1="10" x2="21" y2="10"></line>
                                                            </svg>
                                                        </div>

                                                        <MaintenanceCalendarDialog
                                                            show={showCalendar}
                                                            onClose={() => setShowCalendar(false)}
                                                            selectedDate={requestForm.date}
                                                            subServiceID={subServiceID}
                                                            onSelect={async (value) => {
                                                                const selectedDate = moment(value).format('yyyy-MM-DD');
                                                                const today = moment().format('yyyy-MM-DD');
                                                                const isToday = selectedDate === today;
                                                                const hasRestricted = subServiceID?.toUpperCase() !== PERIODIC_MAINTENANCE_ID;

                                                                if (isToday && hasRestricted) {
                                                                    setWarningPopup({
                                                                        show: true,
                                                                        message: lang === 'ar'
                                                                            ? "هذه الخدمة لا يمكن حجزها في نفس اليوم، يرجى اختيار تاريخ آخر (ابتداءً من الغد)."
                                                                            : "This service cannot be booked on same day, please choose another date (starting from tomorrow)."
                                                                    });
                                                                    return;
                                                                }

                                                                const val = { ...requestForm };
                                                                val.date = value;
                                                                val.time = null;
                                                                setRequestForm(val);
                                                                setListTimeAvailable([]);

                                                                if (val.date) {
                                                                    await webAvailableReshours(selectedDate, subServiceID);
                                                                }
                                                            }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="grow">
                                                    <div className="basis-2/4 grow">
                                                        <DatePicker
                                                            //     excludeTimes={
                                                            //     listTimeAvailable.map((val, index) => {
                                                            //         const time = new Date();
                                                            //         time.setHours(val, 0, 0);
                                                            //         return time;
                                                            //     })
                                                            // }

                                                            includeTimes={listTimeAvailable.map((val) => {
                                                                const time = new Date();
                                                                let res;

                                                                // Removed local shift limitation as per backend update
                                                                if (requestForm.date && new Date(requestForm.date).toDateString() === new Date().toDateString()) {
                                                                    if (val > new Date().getHours()) {
                                                                        res = time.setHours(val, 0, 0);
                                                                    }
                                                                } else if (requestForm.date && new Date(requestForm.date) > new Date()) {
                                                                    res = time.setHours(val, 0, 0);
                                                                } else {
                                                                    res = time.setHours(val, 0, 0);
                                                                }

                                                                return res;
                                                            })}
                                                            isClearable={!!requestForm.time}
                                                            selected={requestForm.time}
                                                            onChange={(value) => {
                                                                const val = { ...requestForm };
                                                                val.time = value;
                                                                setRequestForm(val);

                                                                if (value) {
                                                                    const selectedHour = moment(value).hour();
                                                                    if ([13, 14, 15].includes(selectedHour)) {
                                                                        toast.warn("السيارة سيتم استلامها من قبل المهندس المختص وسيتم اعلامك عزيزي الضيف بوقت الاستلام بعد الانتهاء من أعمال الصيانة");
                                                                    }
                                                                }
                                                            }}
                                                            className="w-100"
                                                            // filterTime={(time) => {
                                                            //     // Define your custom logic to disable specific times
                                                            //     // For example, disable times before 9:00 AM and after 5:00 PM
                                                            //     const startTime = new Date().setHours(8, 0, 0); // 9:00 AM
                                                            //     const endTime = new Date().setHours(18, 0, 0); // 5:00 PM
                                                            //     return time < startTime || time > endTime;
                                                            //   }}
                                                            placeholderText={trans("form:maintenance-time")}
                                                            showTimeSelect
                                                            showTimeSelectOnly
                                                            timeIntervals={60}
                                                            timeInputLabel={trans("form:maintenance-time")}
                                                            // minTime={
                                                            //     (requestForm.date && new Date(requestForm.date).getDate() > new Date().getDate()) 
                                                            //         ? new Date().setHours(8, 0, 0) 
                                                            //         :(new Date().getHours() > 19 
                                                            //             ? new Date().setHours(18, 55, 0) 
                                                            //             : new Date().setHours(new Date().getHours(), new Date().getMinutes(), 0) ) }
                                                            // maxTime={new Date().setHours(18, 59, 0)}
                                                            timeCaption={trans("form:maintenance-time")}
                                                            // withPortal
                                                            dateFormat="hh:mm aa"
                                                            // showTimeInput
                                                            customInput={<DateInput3
                                                            //  value={requestForm.time} 

                                                            />}

                                                        // customTimeInput={<DateInput3 />}
                                                        />
                                                    </div>
                                                </div>

                                                {/* <div className="grow">
                                                    <div className="basis-2/4 grow">

                                                        <DateInput
                                                            extraClasses={"border-none  text-30  border-radius-sm "}
                                                            errorLabel={error?.date}
                                                            type={"date"}
                                                            placeholder={trans("form:maintenance-date")}
                                                            value={requestForm.date}
                                                            length={255}
                                                            onSelect={
                                                                (e) => {
                                                                    //////console.log(">>>>>>>>>>>>>:", e.target.value);
                                                                    if (e.target.value >= (new Date().toJSON().slice(0, 10)) || !e.target.value) {
                                                                        const val = { ...requestForm };
                                                                        val.date = e.target.value;
                                                                        setRequestForm(val);
                                                                    }
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                <div className="grow">
                                                    <div className="basis-2/4 grow">

                                                        <DateInput
                                                            extraClasses={"border-none  text-30  border-radius-sm "}
                                                            errorLabel={error?.time}
                                                            type={"time"}
                                                            placeholder={trans("form:maintenance-time")}
                                                            value={requestForm.time}
                                                            length={255}
                                                            onSelect={
                                                                (e) => {
                                                                    const val = { ...requestForm };
                                                                    val.time = e.target.value;
                                                                    setRequestForm(val);
                                                                }
                                                            }
                                                        />
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="flex flex-row grid-2-cols nice-gap-2rem ">


                                                <div className="basis2/4 grow">

                                                    <InputField
                                                        errorLabel={error?.meterReading}

                                                        placeholder={trans("info:meter-reading")}
                                                        type='number'
                                                        value={requestForm?.meterReading}
                                                        onChangeValue={(e) => {
                                                            const val = { ...requestForm };
                                                            val.meterReading = e.target.value;
                                                            setRequestForm(val);

                                                        }} />
                                                </div>

                                                <DropDownInput
                                                    // title={trans("info:branch")}
                                                    errorLabel={error?.SiteID}
                                                    options={[
                                                        ...Branches.map(B => {
                                                            return { value: B.SiteID, text: lang === 'ar' ? B.DescriptionAr : B.DescriptionEn };
                                                        })]}
                                                    selectedValue={Branches?.length == 1 ? Branches[0]?.SiteID : requestForm?.SiteID}
                                                    onSelect={(value) => {

                                                        //////console.log("onSelect:", value);
                                                        const val = { ...requestForm };
                                                        val.SiteID = value;
                                                        setRequestForm(val);
                                                    }}

                                                />
                                            </div>



                                            <div className="grow input  ">

                                                {/* <ErrorLabel errorTitle={error?.file} /> */}
                                                <UploadControl
                                                    accept={"image/*"}
                                                    placeholder={trans("info:Form_file")}
                                                    errorLabel={error?.identificationImage}
                                                    extraClasses={"border-none border-radius-sm  text-24 "}
                                                    value={requestForm?.fileName}
                                                    onPicker={async (e) => {
                                                        const { target } = e;
                                                        const { files } = target;
                                                        const loadedImage = files[0];


                                                        if (loadedImage) {
                                                            if (!loadedImage.type.startsWith("image/")) {
                                                                toast.error(trans('Please select a valid image file!'));
                                                                const val = { ...requestForm };
                                                                val.file = "";
                                                                val.fileName = "";
                                                                setRequestForm(val);

                                                                return;
                                                            }
                                                        }
                                                        // loadedImage will be a image file.
                                                        if (target.value && loadedImage?.name) {
                                                            const size = loadedImage.size;
                                                            const finalCheck = Math.round((size / 1024));
                                                            if (finalCheck >= 4096) {
                                                                toast.error(trans('new:file_size_error'));
                                                                return;
                                                            }

                                                            const val = { ...requestForm };
                                                            val.fileName = loadedImage?.name;
                                                            const fileBase64 = await toBase64(loadedImage);
                                                            const finalFile = fileBase64.substr(fileBase64.indexOf(',') + 1, fileBase64.length);
                                                            val.file = finalFile;
                                                            setRequestForm(val);
                                                        } else {
                                                            const val = { ...requestForm };
                                                            val.file = "";
                                                            val.fileName = "";
                                                            setRequestForm(val);
                                                        }
                                                    }} />
                                            </div>




                                            <TextArea
                                                value={Note}
                                                row={3}
                                                placeholder={trans("info:notes")}
                                                onChangeValue={(data) => {
                                                    setNote(data);
                                                }}
                                            />

                                        </>

                                    }



                                </>
                            }

                        </div>
                        <div className="ruler-2 mb-3"></div>
                        {

                            <>
                                <div className="flex nice-justifiy-end gap-2 py-10 px-5">


                                    {

                                        <div className=" mb-1 ">

                                            {
                                                stepNum > 1 &&
                                                <div className="nice-bg-btn bg-black text-white text-20  p-5 " onClick={() => {
                                                    if (stepNum > 1)
                                                        setStepNum(stepNum - 1);
                                                }}>


                                                    {trans("info:back")}


                                                    <div className={" mx-2 " + (lang == "ar" ? "  " : " rotate-180 ")}>

                                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="25" viewBox="0 0 448 512" >
                                                            <path fill="#3bd461" strokeWidth="2" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                                                        </svg>



                                                    </div>
                                                </div>
                                            }

                                        </div>
                                    }

                                    {

                                        <div className=" mb-1 ">

                                            {
                                                stepNum < 2 &&
                                                <div className="nice-bg-btn bg-primary text-white text-20 p-5 " onClick={async () => {

                                                    const num = await checkDataFullNum();

                                                    if (num >= (stepNum)) {

                                                        if (stepNum < 2)
                                                            setStepNum(stepNum + 1);

                                                        if (Object.keys(error).length > 0) {
                                                            setError({});

                                                        }
                                                    } else {
                                                        checkErrors();
                                                    }

                                                }}>
                                                    {trans("form:next")}
                                                    <div className={" mx-2 " + (lang == "ar" ? " rotate-180 " : "")}>

                                                        <svg xmlns="http://www.w3.org/2000/svg" height="20" width="25" viewBox="0 0 448 512" >
                                                            <path fill="#ffffff" strokeWidth="2" d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" />
                                                        </svg>

                                                    </div>


                                                </div>
                                            }

                                        </div>
                                    }



                                </div>

                                {
                                    dataFullNum >= 2 &&
                                    <div className="nice-row py-10 px-5 nice-flex-center ">
                                        <div className="nice-col-md-6 mb-5">
                                            <div className="nice-bg-btn bg-primary text-white text-24" onClick={() => {

                                                var cleanData = {};
                                                try {
                                                    cleanData = JSON.parse(getData(User_Data_Key, true));
                                                } catch (e) {


                                                }

                                                if (isSendeng == false)
                                                    SendResreve(VIN, SerciveID, cleanData?.custID, infoPrice[0].Price);

                                            }}>
                                                {trans("info:reserve")}

                                                {
                                                    isSendeng && <span className='mx-2 loading-btn '>
                                                        <img alt="" src='/assets/icons/loading.svg' width='25' height='25' />
                                                    </span>
                                                }

                                            </div>
                                        </div>
                                        {/* <div className="nice-col-md-6 mb-5">
                                            <div className={"nice-bg-btn  text-24 text-white gap-3r " + (infoPrice[0].Price ? "bg-black" : "bg-gray")} onClick={() => {

                                                if (infoPrice[0].Price) {

                                                    setIsSendeng(true);


                                                    var brandDesc = settings?.brands?.filter(a => a.brandID == brand)[0];
                                                    var groupDesc = settings?.groups?.filter(a => a.productGroupID == group)[0];
                                                    var typeDesc = settings?.productModels?.filter(a => a.productTypeID == type)[0];
                                                    var ServiceDesc = Service?.filter(a => a.ServiceID == SerciveID)[0];
                                                    var objectCart =
                                                    {
                                                        id: modelCode + '-' + SerciveID,
                                                        productID: SerciveID,
                                                        name: ServiceDesc.ServiceNameAR,
                                                        nameEn: ServiceDesc.ServiceName,
                                                        // image :img,
                                                        modelTypeID: VIN,
                                                        modelCode: modelCode,
                                                        price: infoPrice[0].Price,
                                                        Type: "service",
                                                        brand: brandDesc?.descriptionAr
                                                        , brandEn: brandDesc?.descriptionEn
                                                        , group: groupDesc?.descriptionAr
                                                        , groupEn: groupDesc?.descriptionen
                                                        , BrandID: brand
                                                        , modelTypes: typeDesc?.descriptionAr
                                                        , modelTypesEn: typeDesc?.descriptionEn
                                                        ,Orderdate :fullDatetime


                                                    }
                                                    changecartItem(SerciveID, null, VIN, 1, modelCode, null,objectCart,fullDatetime );


                                                    setTimeout(() => {


                                                        setIsSendeng(false);


                                                        setSerciveID(null);
                                                        setselsub0({ ID: "0", desAr: "اختيار  قيمة", desEn: "chose" });
                                                        setService([]);
                                                        setinfoPrice([{ Price: 0 }]);
                                                        setRequestForm({
                                                            lastName: '',
                                                            firstName: '',
                                                            phone: '',
                                                            email: '',
                                                            subject: '',
                                                            date: '',
                                                            time: '',
                                                            messageContent: '',
                                                            myCarID: '',
                                                            SiteID: null,
                                                        });
                                                        setStepNum(1);
                                                        setDataFullNum(0);

                                                        setMaintenanceObj({
                                                            showPopup: false, type: "Notset", main: "", sub1: "", sub2: ""
                                                        });


                                                    }, 1000);


                                                } else {
                                                    toast.warning(trans("info:can_reserve_service"));
                                                    setIsSendeng(false);

                                                }
                                            }
                                            }>
                                                {trans("info:add_to_cart")} <img src="/assets/icons/cart.svg" className="filtter-primary" />

                                                {
                                                    isSendeng && <span className='mx-2 loading-btn '>
                                                        <img src='/assets/icons/loading.svg' width='25' height='25' />
                                                    </span>
                                                }
                                            </div>
                                        </div> */}
                                    </div>
                                }

                            </>
                        }

                    </div>
                </div>
            </Popup>


            <Popup show={showFinalPopup}>
                <div className="w-full h-full flex justify-center items-center" >
                    <div className="cart-finalized" ref={popRef}>
                        <div className="cart-finalized-container flex flex-col">

                            <div className="cart-finalized-container-img flex flex-col">
                                <img src="/assets/images/finalized.svg" />
                            </div>

                            <div className="flex flex-wrap justify-center">
                                <span className="text-20 font-bold text-black mx-2 unselectable ">{trans("new:thank_to_choose")}</span>
                                <span className="text-20 font-bold text-primary mx-2"> {trans("new:HJ_cars")}</span>
                            </div>

                            {
                                <>
                                    <div className="flex flex-row justify-center">
                                        <span className="text-20 font-bold  mx-2"> {trans("new:The_appointment_has_been_booked")}</span>
                                    </div>
                                    <div className="flex flex-row justify-center">
                                        <span className="text-20 font-bold  mx-2"> {trans("new:You-will-be-contacted")}</span>
                                    </div>

                                    {

                                        resOrderID &&
                                        <div className="flex flex-row justify-center cart-finalized-code"
                                            onClick={() => {

                                                navigator.clipboard.writeText(resOrderID);
                                            }}

                                        >

                                            <span className="text-20 font-bold text-white  mx-2"> {trans("new:Reservation_number") + " :"}</span>
                                            <span className="text-20 font-bold text-white  mx-2">{resOrderID && resOrderID}</span>
                                            <img src="/assets/icons/copy.svg" alt='' />
                                        </div>
                                    }

                                </>

                            }



                            <div className="flex flex-center flex-col  mt-5 pt-5 w-80">
                                <div className=" mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go  bg-primary text-white text-16" onClick={() => {

                                        setShowFinalPopup(false);
                                        setResOrderID(null);
                                        if (location.pathname)
                                            history.push(location.pathname);

                                    }}>
                                        {trans("cartFile:Continue_browsing")}
                                    </div>
                                </div>
                            </div>

                        </div>


                    </div>


                </div>
            </Popup>
            <Popup show={warningPopup.show}>
                <div className="w-full h-full flex justify-center items-center">
                    <div className="cart-finalized" style={{ minHeight: '200px' }}>
                        <div className="cart-finalized-container flex flex-col p-8">
                            <div className="flex flex-wrap justify-center mb-6">
                                <span className="text-20 font-bold text-black text-center unselectable">{warningPopup.message}</span>
                            </div>
                            <div className="flex flex-center flex-col mt-5 w-80">
                                <div className="mb-5 w-100">
                                    <div className="nice-sm-btn cart-notification-go bg-primary text-white text-16"
                                        onClick={() => setWarningPopup({ show: false, message: '' })}>
                                        {lang === 'ar' ? "موافق" : "OK"}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
        </>
    );
}

export default ServiceOrderPopup;